module.exports = __webpack_public_path__ + "static/a-farewell-to-arms-27061e76387719747f540af0326b1c24.jpg";